import {
    HeroImage,
    StaticPageLoadingPlaceholder,
    useAnalyticsActionTracker,
    useOidcAuthentication,
} from '@cp-shared-19/frontend-ui';
import React from 'react';
import { useLogin } from '../../../auth/useLogin';
import { withLoadingAndNoConnectionHandler } from '../../integration-wrapper';
import { dashboardPagePath } from '../../navigation/paths';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useLandingPage } from '../../landing-page/useLandingPage';

export const AutoLogoutPage: React.FC = () => {
    const HeroImageWithHandlers = withLoadingAndNoConnectionHandler(HeroImage);
    const login = useLogin();
    const { cmsContent: landingPage, isLoading, loadingError } = useLandingPage();
    const { isAuthenticated } = useOidcAuthentication();
    const params = new URLSearchParams(location.search);
    const manual = params.get('manual');
    const history = useHistory();

    const { onAction } = useAnalyticsActionTracker('login');

    const loginHandler = async (): Promise<void> => {
        onAction();
        return await login();
    };

    const loginHandlerAuthenticated = async (): Promise<void> => {
        onAction();
        history.push(dashboardPagePath());
    };

    const { t } = useTranslation('landing-page');
    return (
        <HeroImageWithHandlers
            isLoading={isLoading}
            hasError={!!loadingError}
            pretitle={t('logout.pretitle')}
            imageUrl={landingPage?.imageUrl}
            inverted={landingPage?.isInverted}
            title={manual ? t('logout.title-manual') : t('logout.title')}
            subTitle={manual ? t('logout.subTitle-manual') : t('logout.subTitle')}
            buttonText={manual ? t('logout.buttonText-manual') : t('logout.buttonText')}
            clickHandler={isAuthenticated ? loginHandlerAuthenticated : loginHandler}
            loadingPlaceholder={<StaticPageLoadingPlaceholder withHeroTeaser={false} />}
        />
    );
};
